import React, { useEffect, useState } from 'react';
import { Section } from './ui/Section';
import { Camera, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Gallery() {
  const [selectedPhoto, setSelectedPhoto] = useState<{
    url: string;
    alt: string;
  } | null>(null);
  const photos = [{
    id: 1,
    url: 'https://cdn.magicpatterns.com/uploads/aJnvJsKsuV48jLUzK98Q6E/photo-03.jpg',
    alt: 'Band performing live',
    class: 'col-span-1 md:col-span-2 row-span-1 aspect-video md:aspect-auto'
  }, {
    id: 2,
    url: 'https://cdn.magicpatterns.com/uploads/xciBPu2NCPSvhQLggJ1LEq/photo-2.jpg',
    alt: 'Bass and acoustic guitar players',
    class: 'col-span-1 row-span-2 aspect-[3/4] md:aspect-auto'
  }, {
    id: 3,
    url: 'https://cdn.magicpatterns.com/uploads/xpL3DeF77dUwUQrtDD7UUE/photo-1.jpg',
    alt: 'Full band posing in garage',
    class: 'col-span-1 md:col-span-2 row-span-1 aspect-video md:aspect-auto'
  }];
  useEffect(() => {
    if (selectedPhoto) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [selectedPhoto]);
  return <Section id="gallery" className="bg-tx-midnight border-y border-tx-saddle" data-id="element-109">
      <div className="text-center mb-16" data-id="element-110">
        <h2 className="text-5xl md:text-7xl text-tx-parchmentLight mb-4 uppercase" data-id="element-111">
          On The <span className="text-tx-whiskey" data-id="element-112">Road</span>
        </h2>
        <div className="w-24 h-1 bg-tx-whiskey mx-auto" data-id="element-113"></div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 auto-rows-[300px] md:auto-rows-[350px] gap-4 max-w-6xl mx-auto" data-id="element-114">
        {photos.map(photo => <div key={photo.id} onClick={() => setSelectedPhoto({
        url: photo.url,
        alt: photo.alt
      })} className={`relative group overflow-hidden bg-tx-midnight border border-tx-saddle cursor-pointer ${photo.class}`} data-id="element-115">
            <img src={photo.url} alt={photo.alt} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105" data-id="element-116" />

            <div className="absolute inset-0 opacity-20 z-10 mix-blend-overlay pointer-events-none" style={{
          backgroundImage: 'url(\'data:image/svg+xml,%3Csvg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"%3E%3Cfilter id="noiseFilter"%3E%3CfeTurbulence type="fractalNoise" baseFrequency="0.8" numOctaves="3" stitchTiles="stitch"/%3E%3C/filter%3E%3Crect width="100%25" height="100%25" filter="url(%23noiseFilter)"/%3E%3C/svg%3E\')'
        }} data-id="element-117"></div>

            <div className="absolute inset-0 bg-tx-midnight/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20 flex flex-col items-center justify-center" data-id="element-118">
              <Camera className="w-10 h-10 text-tx-whiskey mb-3" data-id="element-119" />
            </div>

            <div className="absolute inset-0 border-2 border-transparent group-hover:border-tx-whiskey/50 transition-colors duration-300 z-30 pointer-events-none" data-id="element-120"></div>
          </div>)}
      </div>

      <AnimatePresence data-id="element-121">
        {selectedPhoto && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 z-[100] flex items-center justify-center bg-black/95 backdrop-blur-sm p-4 md:p-8" onClick={() => setSelectedPhoto(null)} data-id="element-122">
            <button className="absolute top-6 right-6 z-[110] p-2 text-tx-parchmentLight/70 hover:text-tx-ember transition-colors bg-tx-midnight/50 rounded-full backdrop-blur-md border border-tx-saddle" onClick={e => {
          e.stopPropagation();
          setSelectedPhoto(null);
        }} data-id="element-123">
              <X className="w-8 h-8" data-id="element-124" />
            </button>

            <motion.img initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 300
        }} src={selectedPhoto.url} alt={selectedPhoto.alt} className="max-w-full max-h-full object-contain border border-tx-saddle shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-125" />
          </motion.div>}
      </AnimatePresence>
    </Section>;
}